import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tuozhuai",
  "use": "icon-tuozhuai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"icon-tuozhuai\"><path d=\"M448 784v128h-128v-128h128z m256 0v128h-128v-128h128z m-256-224v128h-128v-128h128z m256 0v128h-128v-128h128z m-256-224v128h-128v-128h128z m256 0v128h-128v-128h128z m-256-224v128h-128v-128h128z m256 0v128h-128v-128h128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol